export default __webpack_public_path__ + "static/media/fb.bc0c6a6a.svg";